// extracted by mini-css-extract-plugin
export default {"popper":"_1hsWhpE_8q5j08rAeYEpVm","results":"_3NQri3HtURIXK0lJZMmHvQ"};